import axios from "axios"
import { apiURL } from 'config/globals'

const superAdminRole = 1
const adminRole = 2
const managerRole = 3
const editorRole = 4

const entityDashboardUrl = '/museum/dashboard'

const roleNames = {
    '1': 'Super Admin',
    '2': 'Admin',
    '3': 'Manager',
    '4': 'Editor',
    '5': 'User'
}

const checkLoginAuth = async (navigate) => {

    const response = await axios.post(`${apiURL}/check-user`, {
        'jwt': getAuthToken()
    })

    if (!response.data.success) {
        clearAuthToken()
        return
    }

    jumpToDashboard(navigate, response.data.user.entityId)
}

const checkAuth = async (navigate) => {
    const response = await axios.post(`${apiURL}/check-user`, {
        'jwt': getAuthToken()
    })

    if (!response.data.success) {
        clearAuthToken()
        navigate(`/`)
    }

    return response.data.user
}

const authForm = (form) => {
    form.jwt = getAuthToken()
    return form
}

const getAuthToken = () => {
    return localStorage.getItem('jwt')
}

const setAuthToken = (authToken) => {
    localStorage.setItem('jwt', authToken)
}

const clearAuthToken = () => {
    localStorage.removeItem('jwt')
}

const logout = async (navigate) => {
    clearAuthToken()
    navigate('/')
}

const isSuperAdmin = (currentUser) => {
    return parseInt(currentUser.role) === superAdminRole
}

const hasAdminPermissions = (currentUser) => {
    return parseInt(currentUser.role) <= adminRole
}

const hasManagerPermissions = (currentUser) => {
    return parseInt(currentUser.role) <= managerRole
}

const hasEditorPermissions = (currentUser) => {
    return parseInt(currentUser.role) <= editorRole
}

const getRoleName = (currentUser) => {
    return roleNames[currentUser.role]
}

const getEntityName = async (currentUser) => {
    try {
        const response = await axios.get(`${apiURL}/get-museum/${currentUser.entityId}`)

        if (!response.data.success) {
            return ""
        }

        return response.data.item.name
    } catch (error) {
        return ""
    }
}

const jumpToAdminDashboard = (navigate) => {
    navigate('/museums')
}

const jumpToEntityDashboard = (navigate, entityId) => {
    navigate(`/museum/${entityId}/dashboard`)
}

const jumpToDashboard = (navigate, entityId) => {
    if (entityId) {
        jumpToEntityDashboard(navigate, entityId)
        return
    }

    jumpToAdminDashboard(navigate)
}

export {
    checkLoginAuth,
    checkAuth,
    getAuthToken,
    authForm,
    setAuthToken,
    clearAuthToken,
    logout,
    isSuperAdmin,
    hasAdminPermissions,
    hasManagerPermissions,
    hasEditorPermissions,
    getRoleName,
    getEntityName,
    jumpToDashboard,
}